import { createContext } from 'react';

import { noop } from '@infinex-private/ts-utils/function';

type ToasterContextValue = {
  placement: 'bottom' | 'top';
  isExpanded: boolean;
  toggleExpanded: () => void;
};

export const ToasterContext = createContext<ToasterContextValue>({
  placement: 'bottom',
  isExpanded: false,
  toggleExpanded: noop,
});
